module.exports = __webpack_public_path__ + "static/media/pov_whole_polytope_52_5_3.b188eb4c.png";